import { useDateTimeFormat } from "./useDateTimeFormat";
import * as React from "react";
import { Fragment, useMemo } from "react";
export function TemporalFormat(props) {
    const { value, dateStyle, timeStyle, locale, timeZone, } = props;
    const options = useMemo(() => ({
        dateStyle,
        timeStyle,
        timeZone,
    }), [dateStyle, timeStyle]);
    const dateTimeFormat = useDateTimeFormat(options, locale);
    const str = useMemo(() => {
        return value != null ? dateTimeFormat.format(value) : "";
    }, [dateTimeFormat, value]);
    return React.createElement(Fragment, null, str);
}
//# sourceMappingURL=TemporalFormat.js.map